var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        clip-rule: evenodd;\n        fill: #fff;\n      }\n\n      .st1 {\n        clip-path: url(#clippath-1);\n        fill: #fff;\n      }\n\n      .st2 {\n        fill-rule: evenodd;\n        fill: #fff;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,16.5c-3.6,0-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5,1.3,0,1.8.3c-2.7.8-4.6,3.3-4.6,6.2s1.9,5.4,4.6,6.2c-.6.2-1.2.3-1.8.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210.1,
    y: -40.5,
    width: 1440,
    height: 1065
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.3,16.5c-3.6,0-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5,1.3,0,1.8.3c-2.7.8-4.6,3.3-4.6,6.2s1.9,5.4,4.6,6.2c-.6.2-1.2.3-1.8.3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1210.1,
    y: -40.5,
    width: 1440,
    height: 1065
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 2.5,
    width: 10.3,
    height: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.e5f5d6a53933dac28d3434f8e27101a7.svg";
export { ForwardRef as ReactComponent };